export const COACHES_DATA = [
  {
    name: "Candace Barr",
    rating: "4.9",
    clients: 450,
    years: 12,
    specializesIn: "Consulting careers",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/photos/Coach_Candace_Jobtestorg.png"
  },
  {
    name: "David Kim",
    rating: "4.9",
    clients: 500,
    years: 10,
    specializesIn: "Leadership development",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_David_Jobtestorg.webp"
  },
  {
    name: "Kristen Kenner",
    rating: "4.8",
    clients: 320,
    years: 7,
    specializesIn: "Marketing careers",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/photos/Coach_Kenner_Jobtestorg.jpg"
  },
  {
    name: "Christen Frank",
    rating: "4.9",
    clients: 662,
    years: 14,
    specializesIn: "Mindset coaching",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Christen_Jobtestorg.webp"
  },
  {
    name: "Linda Lutz",
    rating: "5.0",
    clients: 976,
    years: 15,
    specializesIn: "Leadership coaching",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/photos/Coach_Linda_Jobtestorg.png"
  },
  {
    name: "Elisha Austin",
    rating: "4.8",
    clients: 750,
    years: 11,
    specializesIn: "Career transitions",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Elisha_Jobtestorg.webp"
  },
  {
    name: "Zanetta Siciliano",
    rating: "4.9",
    clients: 882,
    years: 15,
    specializesIn: "Salary negotiation",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Zanetta_Jobtestorg.png"
  },
  {
    name: "Nancy Lysandrou",
    rating: "4.8",
    clients: 652,
    years: 15,
    specializesIn: "Talent management",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Nancy_Jobtestorg.png"
  },
  {
    name: "Julie MacWilliams",
    rating: "4.8",
    clients: 701,
    years: 10,
    specializesIn: "Career reentry",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Julie_Jobtestorg.png"
  },
  {
    name: "Queen Ofori",
    rating: "4.9",
    clients: 533,
    years: 8,
    specializesIn: "Interview preparation",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Queen_Jobtestorg.webp"
  },
  {
    name: "Sasha Green",
    rating: "4.8",
    clients: 662,
    years: 12,
    specializesIn: "Insurance careers",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Sasha_Jobtestorg.webp"
  },
  {
    name: "Erin Howard",
    rating: "4.8",
    clients: 713,
    years: 9,
    specializesIn: "UX/UI careers",
    image: "https://jobtestorg-misc.s3.us-east-2.amazonaws.com/app-assets/coaches/Coach_Erin_Jobtestorg.webp"
  }
]
